module.exports = __webpack_public_path__ + "img/26.7c69a910.png";